import { TmHttpClient } from '@treasury/core/http';

export default class FxWireRequest {
    public static async getCorpayProductFeatureConfigurations() {
        return (await TmHttpClient.getInstance()).request(`corpayProductFeatureConfigurations`);
    }

    public static async saveCorpayProductFeatureConfigurations(sharedSecretKey: string) {
        return (await TmHttpClient.getInstance()).request(`corpayProductFeatureConfigurations`, {
            method: 'POST',
            body: {
                SharedSecretKey: sharedSecretKey,
            },
        });
    }
}
